import React from 'react'
import IconFont, { IconPropsWithoutType } from '../IconFont'
const Icon = (props: IconPropsWithoutType) => (
  <IconFont {...props} type="pencil" />
)
export default Icon
